package fr.frux.core.designsystem.interaction

import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalFocusManager

/**
 * Ferme le clavier (via [androidx.compose.ui.focus.FocusManager.clearFocus]) au premier geste posé
 * n'importe où sous ce conteneur, sans jamais consommer l'évènement (#126) : appliqué sur le
 * conteneur racine d'un écran à saisie, à côté — pas à la place — des `clickable`/gestes propres
 * des éléments enfants.
 *
 * Observation en passe [PointerEventPass.Initial] et aucun `change.consume()` : c'est ce qui rend
 * le modifier transparent aux gestes qu'il survole. Sur Explorer, la carte plein cadre est une
 * surface persistante composée SOUS ce chrome (ADR 0009), pas un descendant de ce conteneur — sans
 * cette non-consommation le pan/pinch de la carte ne recevrait jamais l'évènement. Un bouton ou un
 * champ enfant garde lui aussi son propre geste intact : ce modifier ne fait qu'observer.
 *
 * Volontairement pas [androidx.compose.foundation.gestures.detectTapGestures] : ce détecteur
 * consomme le down pendant sa détection de slop, ce qui suffit à annuler un pan de carte démarré au
 * même endroit puisqu'il tourne sur la passe Main, en amont du geste de la carte en dessous.
 */
fun Modifier.clearFocusOnTap(): Modifier =
    composed {
        val focusManager = LocalFocusManager.current
        pointerInput(Unit) {
            awaitEachGesture {
                awaitFirstDown(requireUnconsumed = false, pass = PointerEventPass.Initial)
                val up = waitForUpOrCancellation(pass = PointerEventPass.Initial)
                if (up != null) {
                    focusManager.clearFocus()
                }
            }
        }
    }
